import { CommonModule, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import {
 InjectionToken,
 NgModule,
 PLATFORM_ID,
 TransferState,
 makeStateKey,
 inject,
 isDevMode,
} from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, UrlSerializer } from '@angular/router';
import { GlobalHttpErrorHandler } from '@core/interceptors/global-http-error-handler.interceptor';
import { LoadingInterceptor } from '@core/interceptors/loading.interceptor';
import { MetaScriptInterceptor } from '@core/interceptors/meta-script.interceptor';
import { UtmInterceptor } from '@core/interceptors/utm.interceptor';
import { TransferHttpCacheModule } from '@nguniversal/common';
import { NotificationComponent } from '@shared/components/notification/notification.component';
import { AppComponent } from './app.component';
import { appRoutes } from './app.routes';
import { LoginRegisterUiService } from './pages/login-register/login-register-ui.service';
import { CustomUrlSerializerService } from './custom-url-serializer';
import { TokenInterceptor } from '@core/interceptors/token.interceptor';
import { RialToTomanPipe } from '@shared/pipes/rial-to-toman.pipe';
export const WINDOW = new InjectionToken<Window>('Window', {
 providedIn: 'root',
 factory: () => window,
});

export const API_IHO_URL = new InjectionToken<string>('API_IHO_URL');
export const SERVER_COOKIES = new InjectionToken<string>('SERVER_COOKIES');
export const EXPRESS_HOST = new InjectionToken<string>('EXPRESS_HOST');
export const cdnUrl = process.env['IHO_CDN_URL'];

export function getBaseUrl(platformId: Object): string {
    if (process.env['NODE_ENV'] == 'development') return 'https://features_prd-699.ihogroup.ir/api/mvc/';
    else {
        const transferState = inject(TransferState);
        let expressHost = inject(EXPRESS_HOST, { optional: true });
        let baseUrl = '';
        const baseUrlKey = makeStateKey<string>('baseUrlKey');
        if (isPlatformServer(platformId)) {
            baseUrl = 'http://' + (expressHost ?? 'www.iranhotelonline.com/api/mvc/');
            transferState.set(baseUrlKey, expressHost);
        } else {
            baseUrl = '/api/mvc/';
        }
        return baseUrl ?? 'https://www.iranhotelonline.com/api/mvc/';
    }
}

@NgModule({
 declarations: [AppComponent, NotificationComponent],
 imports: [
  BrowserModule,
  BrowserAnimationsModule,
  TransferHttpCacheModule,
  RouterModule.forRoot(appRoutes, {
   initialNavigation: 'enabledBlocking',
   onSameUrlNavigation: 'reload',
  }),
  MatDialogModule,
  HttpClientModule,
  CommonModule,
 ],
 providers: [
  LoginRegisterUiService,
  provideClientHydration(),
  { provide: UrlSerializer, useClass: CustomUrlSerializerService },
  {
   provide: API_IHO_URL,
   useFactory: getBaseUrl,
   deps: [PLATFORM_ID],
  },
  {
   provide: WINDOW,
   useFactory: (platformId: Object) => {
    return isPlatformBrowser(platformId) ? window : {};
   },
   deps: [PLATFORM_ID],
  },
  //   { provide: ErrorHandler, useClass: GlobalErrorHandler },
  {
   provide: HTTP_INTERCEPTORS,
   useClass: TokenInterceptor,
   multi: true,
  },
  {
   provide: HTTP_INTERCEPTORS,
   useClass: GlobalHttpErrorHandler,
   multi: true, // because we could have more than one interceptors in our app
  },
  {
   provide: HTTP_INTERCEPTORS,
   useClass: MetaScriptInterceptor,
   multi: true,
  },
  { provide: HTTP_INTERCEPTORS, useClass: UtmInterceptor, multi: true },
  {
   provide: HTTP_INTERCEPTORS,
   useClass: LoadingInterceptor,
   multi: true,
  },
  RialToTomanPipe,
  //   CookieService,
 ],
 bootstrap: [AppComponent],
})
export class AppModule {}
